import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default function groupReducer(state = initialState.inviteCreditState, action: { type: string; data: any }) {
  switch (action.type) {
    case types.GET_USER_INVITE_SUCCESS:
      return state.merge({ ...action.data });
    default:
      return state;
  }
}
